<template>
<div class="label-node-custom">
 <h2 class="titleXY">{{ ((this.node.data.string === "" || this.node.data.string === undefined) ?this.node.name : this.node.data.string)}}</h2> 
    <div class="nodeXY nodeIEx" :class="[selected(), node.name] | kebab">
  <!-- Controls-->
  <div class="controlXY" v-for="control in controls()" v-control="control" :key="control.key"></div>
</div>
</div>
</template>

<script>
import VueRenderPlugin from "rete-vue-render-plugin";
export default {
 mixins: [VueRenderPlugin.mixin],
 components: {
    Socket: VueRenderPlugin.Socket
  },
  watch:{
      node(val){
  var y =  this.node.data.string === undefined  ? this.node.name : this.node.data.string;
        alert (y);
      }
  },
  computed:{
    newTitle(){
        var y =  this.node.data.string === undefined  ? this.node.name : this.node.data.string;
        return  y;
    }
  }
}
</script>

<style lang="sass">
.nodeXY
  background: none
  display: none
  &:hover
     background: none
  &.selected
    display: block
  input
    width: 400px

.titleXY
  font-size: xx-large

</style>
